import { TableWrapper, HeaderWrapper, HeaderRow, HeaderCell, BodyWrapper, BodyRow, BodyCell } from './components/renderers/defaultClassedRenderers.js';
import { renderRowsLoader } from './components/renderers/renderRowsLoader.js';

var defaultRenderers = {
  table: TableWrapper,
  header: {
    wrapper: HeaderWrapper,
    row: HeaderRow,
    cell: HeaderCell
  },
  body: {
    wrapper: BodyWrapper,
    row: BodyRow,
    cell: BodyCell
  }
};

var renderers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultRenderers: defaultRenderers,
  renderRowsLoader: renderRowsLoader
});

export { defaultRenderers as d, renderers as r };
//# sourceMappingURL=index-4a6329dc.js.map
